if (!customElements.get('ct-countdown-bar')) {
  class CtCountdownBar extends HTMLElement {
    connectedCallback() {
      this.endDate = this.dataset.end;
      this.timezone = this.dataset.timezone;
      this.expiredBehavior = this.dataset.expired;

      this.daysEl = this.querySelector('[data-days]');
      this.hrsEl = this.querySelector('[data-hrs]');
      this.minEl = this.querySelector('[data-min]');
      this.secEl = this.querySelector('[data-sec]');

      const diff = this.getTimeRemaining();
      if (diff <= 0) {
        this.onExpired();
      } else {
        this.update();
        this.interval = setInterval(() => this.update(), 1000);
        this.style.display = 'block';
      }
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    getTimeRemaining() {
      const now = new Date();
      let end;

      if (this.timezone === 'local') {
        end = new Date(this.endDate);
      } else {
        const nowInTz = new Date(now.toLocaleString('en-US', { timeZone: this.timezone }));
        const endRaw = new Date(this.endDate);
        const offset = now.getTime() - nowInTz.getTime();
        end = new Date(endRaw.getTime() + offset);
      }

      return end.getTime() - now.getTime();
    }

    update() {
      const diff = this.getTimeRemaining();

      if (diff <= 0) {
        this.onExpired();
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hrs = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const min = Math.floor((diff / (1000 * 60)) % 60);
      const sec = Math.floor((diff / 1000) % 60);

      this.daysEl.textContent = String(days).padStart(2, '0');
      this.hrsEl.textContent = String(hrs).padStart(2, '0');
      this.minEl.textContent = String(min).padStart(2, '0');
      this.secEl.textContent = String(sec).padStart(2, '0');
    }

    onExpired() {
      clearInterval(this.interval);

      if (this.expiredBehavior === 'hide') {
        if (this.style.display === 'block') {
          this.classList.add('hiding');
          setTimeout(() => { this.style.display = 'none'; }, 500);
        }
      } else {
        this.classList.add('expired');
        this.style.display = 'block';
      }
    }
  }

  customElements.define('ct-countdown-bar', CtCountdownBar);
}
